import { options } from '../global-constants';

export const alertMessageLabels = {
	EMPTY_VIEWED_PROFILE_DATA: 'EMPTY_VIEWED_PROFILE_DATA',
	EMPTY_TRACKED_PROFILE_DATA: 'EMPTY_TRACKED_PROFILE_DATA',
	EMPTY_SAVED_PROFILE_DATA: 'EMPTY_SAVED_PROFILE_DATA',
	LESS_INVENTORY_VIEWED_SINGLE: 'LESS_INVENTORY_VIEWED_SINGLE',
	LESS_INVENTORY_TRACKED_SINGLE: 'LESS_INVENTORY_TRACKED_SINGLE',
	LESS_INVENTORY_SAVED_SINGLE: 'LESS_INVENTORY_SAVED_SINGLE',
	LESS_INVENTORY_VIEWED_MULTIPLE: 'LESS_INVENTORY_VIEWED_MULTIPLE',
	LESS_INVENTORY_TRACKED_MULTIPLE: 'LESS_INVENTORY_TRACKED_MULTIPLE',
	LESS_INVENTORY_SAVED_MULTIPLE: 'LESS_INVENTORY_SAVED_MULTIPLE',
	NO_INVENTORY_VIEWED: 'NO_INVENTORY_VIEWED',
	NO_INVENTORY_TRACKED: 'NO_INVENTORY_TRACKED',
	NO_INVENTORY_SAVED: 'NO_INVENTORY_SAVED'
};

export const alertMessageIds = {
	EMPTY_PROFILE_DATA: 'EMPTY_PROFILE_DATA', //  no vehicles are present in the user's profile data
	LESS_INVENTORY: 'LESS_INVENTORY', // When WIS returns less vehicle data than we expect
	NO_INVENTORY: 'NO_INVENTORY' // When WIS returns no inventory
};

const MULTIPLE_ALERT_OBJECT = 'MULTIPLE_ALERT_OBJECT';
const SINGLE_ALERT_OBJECT = 'SINGLE_ALERT_OBJECT';

const alertMessageDictionary = {
	[options.RECENTLY_VIEWED]: {
		[alertMessageIds.EMPTY_PROFILE_DATA]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'EMPTY_PROFILE_DATA',
				heading: '',
				amount: '',
				msg: alertMessageLabels.EMPTY_VIEWED_PROFILE_DATA
			}
		},
		[alertMessageIds.LESS_INVENTORY]: {
			// no message required for less inventory viewed
			[MULTIPLE_ALERT_OBJECT]: {},
			[SINGLE_ALERT_OBJECT]: {}
		},
		[alertMessageIds.NO_INVENTORY]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'NO_INVENTORY',
				heading: alertMessageLabels.LESS_INVENTORY_VIEWED_MULTIPLE,
				amount: '',
				msg: alertMessageLabels.NO_INVENTORY_VIEWED
			},
			[SINGLE_ALERT_OBJECT]: {
				id: 'NO_INVENTORY',
				heading: alertMessageLabels.LESS_INVENTORY_VIEWED_SINGLE,
				amount: '',
				msg: alertMessageLabels.NO_INVENTORY_VIEWED
			}
		}
	},
	[options.TRACKED_PRICE]: {
		[alertMessageIds.EMPTY_PROFILE_DATA]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'EMPTY_PROFILE_DATA',
				heading: '',
				amount: '',
				msg: alertMessageLabels.EMPTY_TRACKED_PROFILE_DATA
			}
		},
		[alertMessageIds.LESS_INVENTORY]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'LESS_INVENTORY',
				heading: '',
				amount: '',
				msg: alertMessageLabels.LESS_INVENTORY_TRACKED_MULTIPLE
			},
			[SINGLE_ALERT_OBJECT]: {
				id: 'LESS_INVENTORY',
				heading: '',
				amount: '',
				msg: alertMessageLabels.LESS_INVENTORY_TRACKED_SINGLE
			}
		},
		[alertMessageIds.NO_INVENTORY]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'NO_INVENTORY',
				heading: alertMessageLabels.LESS_INVENTORY_TRACKED_MULTIPLE,
				amount: '',
				msg: alertMessageLabels.NO_INVENTORY_TRACKED
			},
			[SINGLE_ALERT_OBJECT]: {
				id: 'NO_INVENTORY',
				heading: alertMessageLabels.LESS_INVENTORY_TRACKED_SINGLE,
				amount: '',
				msg: alertMessageLabels.NO_INVENTORY_TRACKED
			}
		}
	},
	[options.SAVED]: {
		[alertMessageIds.EMPTY_PROFILE_DATA]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'EMPTY_PROFILE_DATA',
				heading: '',
				amount: '',
				msg: alertMessageLabels.EMPTY_SAVED_PROFILE_DATA
			}
		},
		[alertMessageIds.LESS_INVENTORY]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'LESS_INVENTORY',
				heading: '',
				amount: '',
				msg: alertMessageLabels.LESS_INVENTORY_SAVED_MULTIPLE
			},
			[SINGLE_ALERT_OBJECT]: {
				id: 'LESS_INVENTORY',
				heading: '',
				amount: '',
				msg: alertMessageLabels.LESS_INVENTORY_SAVED_SINGLE
			}
		},
		[alertMessageIds.NO_INVENTORY]: {
			[MULTIPLE_ALERT_OBJECT]: {
				id: 'NO_INVENTORY',
				heading: alertMessageLabels.LESS_INVENTORY_SAVED_MULTIPLE,
				amount: '',
				msg: alertMessageLabels.NO_INVENTORY_SAVED
			},
			[SINGLE_ALERT_OBJECT]: {
				id: 'NO_INVENTORY',
				heading: alertMessageLabels.LESS_INVENTORY_SAVED_SINGLE,
				amount: '',
				msg: alertMessageLabels.NO_INVENTORY_SAVED
			}
		}
	}
};

export const getMessageObject = (
	facetValue,
	alertMessageId,
	isMultiple = true,
	amount
) => {
	const alert = alertMessageDictionary[facetValue][alertMessageId];
	if (!alert) return {};

	const alertObject =
		alert[isMultiple ? MULTIPLE_ALERT_OBJECT : SINGLE_ALERT_OBJECT];
	if (!alertObject) return {};

	if (amount !== undefined) {
		alertObject.amount = amount;
	}

	return alertObject;
};
